module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1006-034c23725d918a98018ccec5d532743e.png";